import { ServerAdapterBase } from "./ServerAdapterBase.js";
import { Constants as C, methods as M } from "./methods.js";
import { getBrowserInfo } from "../lib/utils.js";

export class HttpAdapter extends ServerAdapterBase {
    constructor(id, isMain) {
        super(id, isMain);
        this.ackSequenceNumber = 0;
        const browserInfo = getBrowserInfo();
        this.browserName = browserInfo.name
        this.browserVersion = browserInfo.version
        this.publishEpoch = 0;
    }

    processSingle(options, callback) {
        this.asyncRequest(options.headers, options.timeout)
            .then((response) => {
                if ((response && response.code === 0) || options.ignoreErrors) {
                    callback && callback(response);
                } else if (!options.ignoreErrors) {
                    this.postError(response, callback, options.callOnError, options.errorCallback);
                }
            })
            .catch(function (e) {
                if (e !== "this adapter was disposed") {
                    console.log(e); // "oh, no!"
                }
            });
    }

    processIntervalStart(options, callback) {
        this.createInterval(this.publishInterval.bind(this), options, callback);
    }

    processIntervalRequest(options, callback) {
        this.createInterval(this.repeatRequest.bind(this), options, callback);
    }

    repeatRequest(data, callback) {
        const { headers, timeout } = data;
        this.asyncRequest(headers, timeout).then((response) => {
            if (response && response.code === 0) {
                callback && callback(response);
            } else {
                this.postError(response, callback);
            }
        });
    }

    postError(answer, callback, callOnError, errorCallback) {
        this._isbusy = false;
        super.postError(answer, callback, callOnError, errorCallback);
    }

    createInterval(intervalMethod, options, callback) {
        if (!this.watchers) {
            return;
        }
        let intervalHandler = options.method;
        const timerInstance = {
            intervalMethod,
            options,
            callback,
            timer: setInterval(
                intervalMethod,
                options.interval,
                options,
                callback
            ),
        };
        this.watchers[intervalHandler] = timerInstance;
    }

    stopInterval(options) {
        const { method } = options;
        this.ackSequenceNumber = 0;
        this.publishEpoch++;
        if (this.watchers && this.watchers[method] !== undefined) {
            if (
                this.watchers[method].options &&
                this.watchers[method].options.methodType === C.intervalStart
            )
                clearInterval(this.watchers[method].timer);
        }
    }

    changeInterval(method, newInterval) {
        const { intervalMethod, options, callback } = this.watchers[method];
        this.stopInterval({ method });
        newInterval && (options.interval = newInterval);
        this.createInterval(intervalMethod, options, callback);
    }

    restartIntervals() {
        this.watchers &&
            Object.keys(this.watchers).forEach((method) => {
                const { options, callback } = this.watchers[method];
                if (options.headers && options.headers.body && this.sessionId) {
                    if (typeof options.headers.body === "string")
                        options.headers.body = JSON.parse(options.headers.body);
                    options.headers.body.sessionId = this.sessionId;
                }

                if (options.headers && options.headers.url)
                    options.headers.url =
                        `//${this.location.hostname}:${this.location.port}` +
                        this.methods(method);

                //    this.stopInterval(options, callback);
                //    this.sendRequest(options, callback);
            });
    }

    publishInterval(data, callback) {
        if (this._isbusy) return;
        this._isbusy = true;
        const epoch = this.publishEpoch;
        const sentSubscriptionId = this.subscriptionId;
        this.asyncRequest({
            body: {
                ackSequenceNumber: this.ackSequenceNumber,
                subscriptionId: sentSubscriptionId,
                sessionId: data.headers.body.sessionId,
            },
            url: data.headers.url,
        }, data.timeout)
            .then((answer) => {
                this._isbusy = false;
                if (epoch !== this.publishEpoch || sentSubscriptionId !== this.subscriptionId) {
                    return;
                }
                if (!(answer && answer.code === 0)) {
                    this.postError(answer, callback);
                    return;
                }
                const seq = answer.sequenceNumber;
                if (answer.sequenceNumber && answer.sequenceNumber > this.ackSequenceNumber) {
                    this.ackSequenceNumber = seq;
                    callback && callback(answer);
                } else if (data.updateTrend) {
                    callback && callback(answer);
                }
            })
            .catch((error) => {
                this._isbusy = false;
                console.log(error);
            });
    }

    async fetchData(obj, timeout) {
        const controller = new AbortController();
        const countDown = setTimeout(() => {
            controller.abort();
        }, timeout || 30000);
        if (typeof obj.body == "object") {
            obj.body = JSON.stringify(obj.body);
        }
        const header ={
            'Browser-Name': this.browserName,
            'Browser-Version': this.browserVersion
        }
        if(obj.headers){
            Object.assign(header, obj.headers);
        }
        return await fetch(obj.url, {
            method: obj.method || "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: header,
            redirect: "follow", // manual, *follow, error
            referrer: "no-referrer", // no-referrer, *client
            body: obj.body, // body data type must match "Content-Type" header
            signal: controller.signal,
        })
            .then((data) => {
                clearTimeout(countDown);
                return data;
            })
            .catch((err) => {
                if (err.name === "AbortError") {
                    return undefined;
                } else {
                    console.log(err);
                }
            });
    }

    async asyncRequest(obj, timeout) {
        if (this.inited) {
            return await this.fetchData(obj, timeout)
                .then((response) => {
                    if (response) {
                        const { status } = response;
                        if (status === 200) {
                            if (!this.isConnected) {
                                this.resetTimeout();
                            }
                            return response.json();
                        }

                        if (status === 500) {
                            return response.json();
                        }
                    }

                    return response;
                })
                .catch((err) => {
                    return { code: 10, err: err.toString() };
                });
        } else {
            this.dispose();
            return Promise.reject("this adapter was disposed");
        }
    }
}
